import { IoMdClose } from 'react-icons/io';
import { AiOutlineNotification } from 'react-icons/ai';
import { HiOutlineSpeakerphone } from 'react-icons/hi';

const AnnounceModal = (props: {
    isOpen: any;
    onClose: any;
    description: any;
}) => {
    const { isOpen, onClose, description } = props;

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[1003] flex items-center justify-center p-4">
            {/* Overlay */}
            <div 
                className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                onClick={onClose}
            />

            {/* Modal */}
            <div className="relative z-[1004] w-full max-w-lg animate-[slideDown_0.3s_ease-out]">
                <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
                    {/* Header avec icône */}
                    <div className="relative bg-gradient-to-br from-blue-600 to-blue-700 p-6 pb-12">
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 p-2 bg-white/20 backdrop-blur-sm hover:bg-white/30 rounded-full transition-all hover:scale-110"
                        >
                            <IoMdClose size={20} className="text-white" />
                        </button>

                        <div className="flex items-center gap-3">
                            <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                                <HiOutlineSpeakerphone size={24} className="text-white" />
                            </div>
                            <h1 className="text-2xl font-bold text-white">
                                Annonce importante
                            </h1>
                        </div>
                    </div>

                    {/* Contenu */}
                    <div className="px-6 pb-6 -mt-8 relative z-10">
                        <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
                            <p className="text-slate-700 leading-relaxed whitespace-pre-wrap">
                                {description}
                            </p>
                        </div>

                        {/* Bouton d'action */}
                        <button
                            onClick={onClose}
                            className="w-full py-3.5 rounded-xl bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold shadow-lg hover:shadow-xl transition-all hover:scale-[1.02]"
                        >
                            Compris !
                        </button>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </div>
    );
};

export default AnnounceModal;